import { render, staticRenderFns } from "./modPassword.vue?vue&type=template&id=060a38ff&scoped=true"
import script from "./modPassword.vue?vue&type=script&lang=js"
export * from "./modPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060a38ff",
  null
  
)

export default component.exports